export const BaseUrl = "https://shop.winstoncellars.com.au";
export const ApiUrl = "https://retailcart.azurewebsites.net";
export const GramId =
  "IGQVJWb2V1eGhYU2hhVWJkdGpEdmF3bl9UZAmc1OTdkaFpuWmVrTHdHN0FSVTBpRFlTMXh4WFp6a1pzUzJ3dl9jeW1CQ3kxR180bG4yZAEZAadU9vaGU0TW4xVTRYbzNLaXg3aE9mbkNGNU55QmxieGIxcgZDZD";
export const StripClientId = "pk_test_s6kImbwpk4E3i46eie9sXOLJ";
